import React from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import TicketImageContainer from './TicketImageContainer';
import TicketInformation from './TicketInformation';
import { useTicketMobileStyles } from './styles';

const TicketMobile = ({ ...props }) => {
  const { tickets, ticket } = props;
  const classes = useTicketMobileStyles();

  return (
    <Box className={classes.container}>
      <Box display="flex" alignItems="center">
        <TicketImageContainer
          isMkp={ticket.isMkp}
          thumbnailImage={ticket.thumbnailImage}
        />
        <TicketInformation tickets={tickets} name={ticket.name} />
      </Box>
    </Box>
  );
};

TicketMobile.propTypes = {
  tickets: PropTypes.array,
  ticket: PropTypes.object,
};

export default TicketMobile;
